<template>
  <div class="date-template">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="日期:">
              <el-date-picker style="width: 100%" :clearable="false" type="date" v-model="searchForm.date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              <el-button type="primary" :loading="downloadLoading" @click="handleDownload(`司机业绩汇总表-${searchForm.date}.xlsx`)">导出</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:totalFee="{ row }">
          <div>总流水: <span class="color526bec">{{row.totalFee}}元</span></div>
          <div>技术服务费: <span class="color526bec">{{row.technicalFee}}元</span></div>
          <div>不可退订金: <span class="color526bec">{{row.deposit}}元</span></div>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import {  downloadExcel, getPage } from "./api";
import dayjs from "dayjs"
import tableMixin from "@/mixin/tableMixin";
export default {
  name: "DriverPerformanceReport",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadExcel,
      searchForm: {
        date: dayjs().format("YYYY-MM-DD"),
      },
      tableColumn: [
        {
          label: "服务商姓名",
          prop: "companyName",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "driverName",
          show: true,
        },
        {
          label: "车牌号",
          prop: "carNumber",
          show: true,
        },
        {
          label: "费用",
          prop: "totalFee",
          scopeStatus: true,
          show: true,
        },
        {
          label: "调度人员",
          prop: "dispatcherName",
          show: true,
        },
        {
          label: "当日派单数",
          prop: "dispatchNum",
          show: true,
        },
        {
          label: "成交数",
          prop: "completeNum",
          show: true,
        },
        {
          label: "公里数",
          prop: "mileage",
          show: true,
        },
        {
          label: "GPS",
          prop: "gpsId",
          show: true,
        },
      ],
      isImmediatelyGetData: true,
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.date-template {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-form-box{
    flex-shrink: 0;
  }
  .custom-table-box {
    flex: 1;
    padding-left: 0;
    padding-top: 0;
  }
}
</style>
